<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <v-card-title>
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <!--                <v-btn :loading="loading" @click="getUserNotification()"-->
                <!--                       class="btn-update">-->
                <!--                  <v-icon>mdi-refresh</v-icon>-->
                <!--                  به روزرسانی-->
                <!--                </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <v-data-table
                    :headers="headers"
                    :items="data"
                    :loading-text="'درحال گرفتن داده ها'"
                    :footer-props="{ itemsPerPageText: 'تعداد ردیف: ' }"
                    :options.sync="options"
                    :no-data-text="'چیزی برای نمایش وجود ندارد!'"
                    :header-props="{ sortByText: 'نمایش برحسب' }"
                    :server-items-length="lenght"
                    :loading="loading"
                    :expanded.sync="expanded"
                    show-expand
                    class="elevation-1"
                  >
                    <template v-slot:item.created_at="{ item }">
                      <v-chip color="green" label small class="text-white">
                        {{
                          persian($options.filters.onlyDate(item.created_at))
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item.time="{ item }">
                      <v-chip color="orange" label small class="text-white">
                        {{
                          persian($options.filters.onlyTime(item.created_at))
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        class="p-4"
                        :colspan="headers.length"
                        v-html="item.data.text"
                      ></td>
                    </template>
                    <template v-slot:item.read_at="{ item }">
                      <v-chip
                        v-if="item.read_at !== null"
                        color="#01BAEF"
                        label
                        small
                        class="text-white"
                      >
                        {{ persian($options.filters.timeAgo(item.read_at)) }}
                      </v-chip>
                      <v-chip
                        v-else
                        color="#DB3069"
                        label
                        small
                        class="text-white"
                      >
                        خوانده نشده!
                      </v-chip>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-container>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "UserNotification",
  data() {
    return {
      totalDesserts: 0,
      data: [],
      isFilter: false,
      footerProps: {
        showFirstLastPage: true,
        firstIcon: "mdi-arrow-collapse-left",
        lastIcon: "mdi-arrow-collapse-right",
        prevIcon: "mdi-minus",
        nextIcon: "mdi-plus",
      },
      expanded: [],
      lenght: null,
      singleExpand: false,
      loading: false,
      options: {},
      headers: [
        {
          text: "شناسه",
          value: "id",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "عنوان",
          value: "data.title",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "نوع اعلان",
          value: "data.type",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "تاریخ ایجاد",
          value: "created_at",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "ساعت ایجاد",
          value: "time",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "تاریخ خواندن",
          value: "read_at",
          align: "center",
          class: "font-weight-bold h6",
        },
        { text: "", value: "data-table-expand" },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      urlNotif: "user-notification",
    };
  },
  methods: {
    getUserNotification(url = this.urlNotif, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.loading = false;
          this.isFilter = true;
          this.data = data.data;
          this.lenght = data.total;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getUserNotification(this.urlNotif);
  },
  watch: {
    options(val) {
      if (this.isFilter) {
        this.tableProps.page = val.page;
        this.tableProps.length = val.itemsPerPage;
        this.tableProps.column = val.sortBy[0] ?? "id";
        if (!val.sortDesc[0]) this.tableProps.dir = "asc";
        else this.tableProps.dir = "desc";
        this.getUserNotification(this.urlNotif, this.tableProps);
      }
    },
  },
};
</script>

<style scoped></style>
